import reducer from './reducers/index';
import objectpath from 'object-path';
import { DefaultSettings, settings } from '../../../settings/settings-util';
import {enableInputBox} from '../../lib-inputbox-toggle/lib/lib-inputbox-toggle';
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';
import { Reducer, Store } from 'redux';
import { AlmeState } from '../../../wireup/AlmeState';
import { AlmeUIInput } from '../../../types/input';

export default class WelcomeUserAppevent 
{
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    
    constructor(passedSettings?: DefaultSettings) 
    {
        this._settings = passedSettings || settings;
    }

    static getDefaultSettings(): DefaultSettings {
        return settings;
    }

    getReducer(): Reducer<{}> {
        return reducer;
    }

    initialize(store: Store<AlmeState>): void {
        this._store = store;
    }

    isActiveSession(): boolean
    {
        //can suppress the welcome user appevent if needed
        const forceIsActiveSession = this._store?.getState()
            [this._settings.stateLocations.WelcomeUser.Base]
            [this._settings.stateLocations.WelcomeUser.forceIsActiveSession];
        const history = this._store?.getState()
            [this._settings.stateLocations.History.Base]
            [this._settings.stateLocations.History.Messages] || [];
            
        return forceIsActiveSession || history.length > 0;
    }

    getPromise(): Promise<void>
    {
        return new Promise((resolve) => {
            // send welcome user if new session and agent is initialized when loading with agent already open
            if(!this.isActiveSession()){
                this.doWelcomeUser(resolve);
            }
            else{
                resolve();
            }
        });
    }

    async doWelcomeUser(resolve): Promise<void>
    {
        const input = {
            messageType : this._settings.messageConstants.appeventRequest,
            eventName : this._settings.appeventConstants.welcomeUserEventName,
            origin : this._settings.originConstants.internal,
            parameters : this.GetWelcomeUserParameters(),
        } as AlmeUIInput;
        
        await sendRequest(input);
        
        const settings = this._settings;

        enableInputBox(this._store, this._settings, () => {
            const windowBaseLoc = settings.stateLocations.Window.Base;
    
            if(settings.stateLocations.Window?.InputBoxLocked)
            {
                const inputBoxLockedLocation = settings.stateLocations.Window?.InputBoxLocked?.Base;
                const enableOnWelcomeLoc = settings.stateLocations.Window?.InputBoxLocked?.ReenableWelcomeUser;
                if(windowBaseLoc && inputBoxLockedLocation && enableOnWelcomeLoc)
                {
                    const state = this._store?.getState();
                    const windowState = objectpath.get(state, windowBaseLoc);
                
                    return windowState[inputBoxLockedLocation][enableOnWelcomeLoc] || false;
                }
            }
    
            return false;
        });
        resolve();
    }

    GetWelcomeUserParameters(): { [key: string]: unknown} {
        const state = this._store?.getState();
        let props: { [key: string]: unknown } = {};

        //Pull WelcomeUser launch params
        const stateParams = objectpath.get(state, this._settings.stateLocations.WelcomeUser.Base);
        const LaunchPointName = stateParams[this._settings.stateLocations.WelcomeUser.launchPointName] || "";
        const LaunchParameter = stateParams[this._settings.stateLocations.WelcomeUser.launchParameter] || "";
        const LaunchType = stateParams[this._settings.stateLocations.WelcomeUser.launchType] || "";

        props = {
            LaunchPointName,
            LaunchParameter,
            LaunchType,
        };
        
        return props;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/appevent-welcomeuser-onlaunch/src/appevent-welcomeuser-onlaunch.ts